/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddBaseReportDTO,
    AddBaseReportDTOFromJSON,
    AddBaseReportDTOToJSON,
    BaseReportDTO,
    BaseReportDTOFromJSON,
    BaseReportDTOToJSON,
    BaseReportDTOPagedResponse,
    BaseReportDTOPagedResponseFromJSON,
    BaseReportDTOPagedResponseToJSON,
    RecommendationDTO,
    RecommendationDTOFromJSON,
    RecommendationDTOToJSON,
    ReportType,
    ReportTypeFromJSON,
    ReportTypeToJSON,
} from '../models';

export interface ApiBaseReportsCreatePostRequest {
    baseReportDTO?: BaseReportDTO;
}

export interface ApiBaseReportsCreateWithFilePostRequest {
    reportDate?: Date;
    studyProgramId?: string;
    file?: Blob;
    description?: string;
    reportType?: ReportType;
    reportTypeValue?: string;
    startDate?: Date;
    recommendations?: Array<RecommendationDTO>;
    recommendationsJson?: string;
}

export interface ApiBaseReportsDeleteIdDeleteRequest {
    id: string;
}

export interface ApiBaseReportsGetAllReportsForProgramProgramIdGetRequest {
    programId: string;
    page?: number;
    pageSize?: number;
    type?: ReportType;
}

export interface ApiBaseReportsGetReportByIdIdGetRequest {
    id: string;
}

export interface ApiBaseReportsUpdateIdPostRequest {
    id: string;
    baseReportDTO?: BaseReportDTO;
}

/**
 * 
 */
export class BaseReportsApi extends runtime.BaseAPI {

    /**
     */
    async apiBaseReportsCreatePostRaw(requestParameters: ApiBaseReportsCreatePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BaseReportDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BaseReports/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BaseReportDTOToJSON(requestParameters.baseReportDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseReportDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiBaseReportsCreatePost(requestParameters: ApiBaseReportsCreatePostRequest = {}, initOverrides?: RequestInit): Promise<BaseReportDTO> {
        const response = await this.apiBaseReportsCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiBaseReportsCreateWithFilePostRaw(requestParameters: ApiBaseReportsCreateWithFilePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AddBaseReportDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.reportDate !== undefined) {
            formParams.append('ReportDate', requestParameters.reportDate as any);
        }

        if (requestParameters.studyProgramId !== undefined) {
            formParams.append('StudyProgramId', requestParameters.studyProgramId as any);
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        if (requestParameters.description !== undefined) {
            formParams.append('Description', requestParameters.description as any);
        }

        if (requestParameters.reportType !== undefined) {
            formParams.append('ReportType', new Blob([JSON.stringify(ReportTypeToJSON(requestParameters.reportType))], { type: "application/json", }));
                    }

        if (requestParameters.reportTypeValue !== undefined) {
            formParams.append('ReportTypeValue', requestParameters.reportTypeValue as any);
        }

        if (requestParameters.startDate !== undefined) {
            formParams.append('StartDate', requestParameters.startDate as any);
        }

        if (requestParameters.recommendations) {
            formParams.append('Recommendations', requestParameters.recommendations.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters.recommendationsJson !== undefined) {
            formParams.append('RecommendationsJson', requestParameters.recommendationsJson as any);
        }

        const response = await this.request({
            path: `/api/BaseReports/CreateWithFile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddBaseReportDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiBaseReportsCreateWithFilePost(requestParameters: ApiBaseReportsCreateWithFilePostRequest = {}, initOverrides?: RequestInit): Promise<AddBaseReportDTO> {
        const response = await this.apiBaseReportsCreateWithFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiBaseReportsDeleteIdDeleteRaw(requestParameters: ApiBaseReportsDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiBaseReportsDeleteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BaseReports/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBaseReportsDeleteIdDelete(requestParameters: ApiBaseReportsDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiBaseReportsDeleteIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiBaseReportsGetAllReportsForProgramProgramIdGetRaw(requestParameters: ApiBaseReportsGetAllReportsForProgramProgramIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BaseReportDTOPagedResponse>> {
        if (requestParameters.programId === null || requestParameters.programId === undefined) {
            throw new runtime.RequiredError('programId','Required parameter requestParameters.programId was null or undefined when calling apiBaseReportsGetAllReportsForProgramProgramIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['PageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BaseReports/GetAllReportsForProgram/{programId}`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseReportDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiBaseReportsGetAllReportsForProgramProgramIdGet(requestParameters: ApiBaseReportsGetAllReportsForProgramProgramIdGetRequest, initOverrides?: RequestInit): Promise<BaseReportDTOPagedResponse> {
        const response = await this.apiBaseReportsGetAllReportsForProgramProgramIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiBaseReportsGetReportByIdIdGetRaw(requestParameters: ApiBaseReportsGetReportByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BaseReportDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiBaseReportsGetReportByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BaseReports/GetReportById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseReportDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiBaseReportsGetReportByIdIdGet(requestParameters: ApiBaseReportsGetReportByIdIdGetRequest, initOverrides?: RequestInit): Promise<BaseReportDTO> {
        const response = await this.apiBaseReportsGetReportByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiBaseReportsUpdateIdPostRaw(requestParameters: ApiBaseReportsUpdateIdPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BaseReportDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiBaseReportsUpdateIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/BaseReports/Update/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BaseReportDTOToJSON(requestParameters.baseReportDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseReportDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiBaseReportsUpdateIdPost(requestParameters: ApiBaseReportsUpdateIdPostRequest, initOverrides?: RequestInit): Promise<BaseReportDTO> {
        const response = await this.apiBaseReportsUpdateIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
